module.exports = __webpack_public_path__ + "static/media/adhd.9127950f.svg";